export default function getResource(label, vars = []) {
    const resources = {
        youAreBookedTitle: 'Vous avez réservé!',
        emailConfirmation: 'Vous recevrez un courriel de confirmation au',
        artist: 'Artiste',
        confirmationNumber: 'Numéro de confirmation',
        addToCalendarButton: 'Ajouter au calendrier',
        rescheduleButton: 'Changer la date',
        cancelButton: 'Annuler',
        viewAllReservations: 'Voir toutes les réservations',
        areYouSure: 'Are you sure you want to cancel?',
        areYouSureWithin24Hours: `Are you sure you want to cancel? Canceling within 24 hours of your appt will incur a ${vars[0]} charge.`,
        seePolicies: 'See policies',
        moreDetails: 'for more details.',
        cancelService: 'Cancel Service',
        no: 'No',
        yes: 'Yes'
    };

    return resources[label];
}
